import React, { FC } from 'react';

import { cn } from '@/shared/lib/tailwind-merge';
import {
    Layout,
    Accordion,
    AccordionItem,
    AccordionTrigger,
    AccordionContent,
    Text,
} from '@/shared/ui';

const FAQ_TEXTS = {
    heading: "FAQ's",
    items: [
        {
            id: '1',
            question: 'How can I earn with Arkis Protocol?',
            answers: [
                <Text key='1' className='text-content-secondary mb-6 leading-6 text-[16px]'>
                    There are two ways you can get yield through Arkis: Agreements and Vaults.
                    Agreements usually refer to the P2P deal between the Lender and Asset Manager
                    where they decide on Lend/Borrow APY, types of collateral accepted, etc. If you
                    are a Lender but still don’t have your own Agreement yet - please contact{' '}
                    <Text
                        type={Text.types.Link}
                        className='text-content-accent1 text-[16px]'
                        href='mailto:operations@arkis.xyz '
                    >
                        operations@arkis.xyz
                    </Text>
                    . Once you have your Agreement - you can Supply your assets to an Agreement and
                    earn passive yield. Even though Agreements are referred to as P2P markets,
                    several Lenders and Asset Managers can participate in the same Agreement.
                </Text>,
                <Text key='2' className='text-content-secondary leading-6 text-[16px]'>
                    On the other hand, Vaults operate like credit funds managed by Credit Managers:
                    Lenders provide their capital to Vaults while Credit Managers distribute them
                    across various Agreements. As a result, the APY earned by Lenders is the
                    weighted average of Agreements APYs. If you want to get whitelisted for
                    supplying to Arkis Vaults or want to create your own Arkis Vault and become a
                    Credit Manager - please contact{' '}
                    <Text
                        type={Text.types.Link}
                        className='text-content-accent1 text-[16px]'
                        href='mailto:operations@arkis.xyz '
                    >
                        operations@arkis.xyz
                    </Text>
                    .
                </Text>,
            ],
        },
        {
            id: '2',
            question: 'How can I withdraw funds from an Agreement?',
            answers: [
                <Text key='3' className='text-content-secondary leading-6 text-[16px]'>
                    On Your Lend tab - click on the pool from which you want to withdraw your funds.
                    If there is available liquidity for withdrawal - you will receive your funds +
                    interest back. If no liquidity is available - your request will be put into the
                    Withdrawal Queue, and the Asset Manager will have 2 weeks to return funds +
                    interest to the liquidity pool.
                </Text>,
            ],
        },
        {
            id: '3',
            question: 'How can I borrow and trade with leverage through Arkis?',
            answers: [
                <Text key='4' className='text-content-secondary leading-6 text-[16px]'>
                    Click on Borrow, and you will see the list of agreements from which you can
                    borrow. Each Agreement defines APY, types of collateral, and risk parameters set
                    between the Lender and Asset Manager. If your list of available Agreements is
                    empty, you don’t have a Lender willing to lend out to you yet. In this case -
                    please contact{' '}
                    <Text
                        type={Text.types.Link}
                        className='text-content-accent1 text-[16px]'
                        href='mailto:operations@arkis.xyz '
                    >
                        operations@arkis.xyz .
                    </Text>
                </Text>,
            ],
        },
    ],
};

type FaqsProps = {
    className?: string;
};

export const Faqs: FC<FaqsProps> = ({ className }) => {
    return (
        <Layout className={cn('mt-[52px] mb-[52px]', className)}>
            <h2 className='pl-5 pb-5 text-lg font-semibold'>{FAQ_TEXTS.heading}</h2>
            <Accordion type='single' collapsible className='border border-border-opaque border-b-0'>
                {FAQ_TEXTS.items.map((item) => (
                    <AccordionItem key={item.id} value={item.id}>
                        <AccordionTrigger className='pt-5 pb-4 pl-6 pr-6 hover:no-underline'>
                            <Text class='text-black font-inter text-[16px] font-semibold leading-[24px] tracking-[-0.03em]'>
                                {item.question}
                            </Text>
                        </AccordionTrigger>
                        <AccordionContent className='pl-6 pr-6 pb-6'>
                            {item.answers.map((text) => {
                                return text;
                            })}
                        </AccordionContent>
                    </AccordionItem>
                ))}
            </Accordion>
        </Layout>
    );
};
